/**
 * Old URLs for the timesheet page, sent on to the current one (`/module/timesheets/id/:id/edit`). They are baked
 * into emails already sent, so they have to keep working.
 */
const redirectToEditTimesheet = (to) => ({ name: "edit-timesheet", params: { id: to.params.id } });



const routes = [


	//---- "Timesheet" pages

	{ 
		path: '/home/timesheets', 
		name: "home-timesheets-view", 
		component: () => import("/home/index.vue"),
		meta: { layout: "primary", layoutType: "default", layoutContainer: "none", isPublic: true, module: "timesheets", parentRouteName: "", pageTitle: "Home", breadcrumbLabel: "Home", kbFile: "home", kbTitle: "" }
	},

	//-- "Practitioner" pages
	{ 
		path: '/module/timesheets/create', 
		name: "timesheet-create", 
		component: () => import("/module.timesheets/create-timesheet.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "Create Timesheet", kbFile: "timesheet", kbTitle: "Timesheet" }
	},

	//TODO: 20 June 2021. The original "read-only" timesheet page is now obsolete. Redirect to edit page (because it has a different layout).
	// { 
	// 	path: '/timesheet', 
	// 	name: "no-selected-timesheet", 
	// 	component: () => import("/module.timesheets/timesheet-page"),
	// 	meta: { layout: "practitioner", pageTitle: "Timesheets > View", satus: "disabled", redirectCode: "home", kbFile: "timesheet", kbTitle: "Timesheet" } 
	// },
	// { 
	// 	path: '/module/timesheets/id/:id', 
	// 	name: "view-timesheet", 
	// 	// component: () => import("/module.timesheets/timesheet-page"),
	// 	component: () => import("/module.timesheets/edit-timesheet-page"),
	// 	meta: { layout: "practitioner", pageTitle: "Timesheets > View", satus: "disabled", redirectCode: "edit-timesheet", kbFile: "timesheet", kbTitle: "Timesheet" } 
	// },

	// //TODO: The following "*/ConfirmViaEmail/*" routes are not yet active. See daily timesheet email in the API for generated links.
	// { 
	// 	path: '/module/timesheets/ConfirmViaEmail/:id/:authToken', 		//:id == timesheetId. Left as ID so standard "timesheet" route also uses it.
	// 	name: "timesheet-confirm-via-email-auth", 
	// 	component: () => import("/module.timesheets/edit-timesheet-page"),
	// 	meta: { layout: "practitioner", pageTitle: "Timesheets > Confirm", satus: "disabled", redirectCode: "home", kbFile: "timesheet", kbTitle: "Timesheet" } 
	// },
	// { 
	// 	path: '/module/timesheets/ConfirmViaEmail/:id', 		//:id == timesheetId. Left as ID so standard "timesheet" route also uses it.
	// 	name: "timesheet-confirm-via-email", 
	// 	component: () => import("/module.timesheets/edit-timesheet-page"),
	// 	meta: { layout: "practitioner", pageTitle: "Timesheets > Confirm", satus: "disabled", redirectCode: "home", kbFile: "timesheet", kbTitle: "Timesheet" } 
	// },
	// { 
	// 	path: '/module/timesheets/ChangeViaEmail/:id/:authToken', 		//:id == timesheetId. Left as ID so standard "timesheet" route also uses it.
	// 	name: "timesheet-change-via-email-auth", 
	// 	component: () => import("/module.timesheets/edit-timesheet-page"),
	// 	meta: { layout: "practitioner", pageTitle: "Timesheets > Change", satus: "disabled", redirectCode: "home", kbFile: "timesheet", kbTitle: "Timesheet" } 
	// },
	// { 
	// 	path: '/module/timesheets/ChangeViaEmail/:id', 		//:id == timesheetId. Left as ID so standard "timesheet" route also uses it.
	// 	name: "timesheet-change-via-email", 
	// 	component: () => import("/module.timesheets/edit-timesheet-page"),
	// 	meta: { layout: "practitioner", pageTitle: "Timesheets > Change", satus: "disabled", redirectCode: "home", kbFile: "timesheet", kbTitle: "Timesheet" } 
	// },
	
	{ 
		path: '/timesheet', 
		name: "no-selected-timesheet", 
		component: () => import("/home/redirect.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "View", satus: "disabled", redirectCode: "home", kbFile: "timesheet", kbTitle: "Timesheet" }
	},
	{
		path: '/module/timesheets/id/:id',
		name: "view-timesheet",
		component: () => import("/home/redirect.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "", pageTitle: "View", satus: "disabled", redirectCode: "edit-timesheet", kbFile: "timesheet", kbTitle: "Timesheet" }
	},

	//TODO: The following "*/ConfirmViaEmail/*" routes are not yet active. See daily timesheet email in the API for generated links.
	{ 
		path: '/module/timesheets/ConfirmViaEmail/:id/:authToken', 		//:id == timesheetId. Left as ID so standard "timesheet" route also uses it.
		name: "timesheet-confirm-via-email-auth", 
		component: () => import("/home/redirect.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "Confirm", satus: "disabled", redirectCode: "home", kbFile: "timesheet", kbTitle: "Timesheet" }
	},
	{
		path: '/module/timesheets/ConfirmViaEmail/:id', 		//:id == timesheetId. Left as ID so standard "timesheet" route also uses it.
		name: "timesheet-confirm-via-email",
		component: () => import("/home/redirect.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "Confirm", satus: "disabled", redirectCode: "home", kbFile: "timesheet", kbTitle: "Timesheet" }
	},
	{
		path: '/module/timesheets/ChangeViaEmail/:id/:authToken', 		//:id == timesheetId. Left as ID so standard "timesheet" route also uses it.
		name: "timesheet-change-via-email-auth",
		component: () => import("/home/redirect.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "Change", satus: "disabled", redirectCode: "home", kbFile: "timesheet", kbTitle: "Timesheet" }
	},
	{
		path: '/module/timesheets/ChangeViaEmail/:id', 		//:id == timesheetId. Left as ID so standard "timesheet" route also uses it.
		name: "timesheet-change-via-email",
		component: () => import("/home/redirect.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "Change", satus: "disabled", redirectCode: "home", kbFile: "timesheet", kbTitle: "Timesheet" }
	},



	//NOTE: The timesheet page - the redesigned page (folder `edit-timesheet2`), the default for everyone since 2026-10-08.
	//		Until then it was on `/edit2` behind the "Edit timesheet v2" testing feature.
	{
		path: '/module/timesheets/id/:id/edit',
		name: "edit-timesheet",
		component: () => import("/module.timesheets/edit-timesheet2/edit-timesheet2.vue"),
		meta: { layout: "primary", layoutContainer: "none", module: "timesheets", parentRouteName: "", pageTitle: "Timesheet - {timesheetDate}", kbFile: "timesheet", kbTitle: "Timesheet" }
	},

	//NOTE: The original timesheet page (folder `edit-timesheet`), kept on its own route for reference and as a fallback.
	//		Not linked from anywhere - reach it by swapping "/edit" for "/edit1" in the URL.
	{
		path: '/module/timesheets/id/:id/edit1',
		name: "edit-timesheet1",
		component: () => import("/module.timesheets/edit-timesheet/edit-timesheet.vue"),
		meta: { layout: "primary", layoutContainer: "none", module: "timesheets", parentRouteName: "", pageTitle: "Timesheet", kbFile: "timesheet", kbTitle: "Timesheet" }
	},

	//NOTE: The redesigned page's testing URL. Rejection and reminder emails sent before 2026-10-08 link to it.
	{
		path: '/module/timesheets/id/:id/edit2',
		name: "edit-timesheet2-old-link",
		redirect: redirectToEditTimesheet,
	},

	//-- Timesheet Approvals workspace. Shown in the navigation only to approvers on accounts with approval switched on
	//		(see approvals-store.js); each page also checks availability itself and shows an empty state rather than calling
	//		the read endpoints. The Overview and Bulk approve share their context in the query string (approvals-query.js).
	{
		path: '/module/timesheets/approvals',
		name: "timesheets-approvals",
		component: () => import("/module.timesheets/approvals/approvals-overview.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "", pageTitle: "Approvals", pageSubtitle: "Review, approve and chase your team's time for the period." }
	},
	{
		path: '/module/timesheets/approvals/bulk',
		name: "timesheets-approvals-bulk",
		component: () => import("/module.timesheets/approvals/approvals-bulk.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "timesheets-approvals", pageTitle: "Approvals > Bulk approve", pageSubtitle: "Approve the days waiting on you in one go." }
	},
	{
		path: '/module/timesheets/approvals/outstanding',
		name: "timesheets-approvals-outstanding",
		component: () => import("/module.timesheets/approvals/approvals-outstanding.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "timesheets-approvals", pageTitle: "Approvals > Outstanding submissions", pageSubtitle: "Everyone with time they haven't submitted yet." }
	},
	{
		path: '/module/timesheets/approvals/day/:timesheetId',
		name: "timesheets-approvals-day",
		component: () => import("/module.timesheets/approvals/approvals-day.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "timesheets-approvals", pageTitle: "Approvals > {timekeeperName} · {dayLabel}" }
	},


	//NOTE: The original URL for the timesheet page prior to the restructure of the platform into modules.
	//		It's still used by daily timesheet emails generated overnight for users, so we need to keep it.
	{
		path: '/timesheets/id/:id/edit',
		name: "edit-timesheet-old-daily-email-link",
		redirect: redirectToEditTimesheet,
	},



	//-- Timesheet "Manager" pages (Team Manager and Project Manager)
	//TODO: Obsolete
	// { 
	// 	path: '/module/timesheets/manager/timesheets-report', 
	// 	name: "timesheets-manager-report",
	// 	component: () => import("/module.timesheets/manager/timesheets-report.vue"),
	// 	meta: { layout: "primary", pageTitle: "Timesheets > Manager > Timesheet Report" } 
	// },
	{ 
		path: '/module/timesheets/manager/outstanding-timesheets', 
		name: "timesheets-manager-outstanding",
		component: () => import("/module.timesheets/manager/outstanding-timesheets.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "Outstanding Timesheets" }
	},
	{ 
		path: '/module/timesheets/manager/manager-users-list', 
		name: "timesheets-manager-users-list",
		component: () => import("/module.timesheets/manager/users-list.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "Users" }
	},


	// Record time in today's timesheet
	{ 
		path: '/module/timesheets/record', 
		name: "record-timesheet", 
		component: () => import("/module.timesheets/time-recorder/index.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "Record Time", kbFile: "timesheet-record-time", kbTitle: "Timesheet > Record Time" }
	},

	{
		path: '/module/timesheets/record/pop',
		name: "record-timesheet-popout-window", 
		component: () => import("/module.timesheets/time-recorder/index.vue"),
		meta: { layout: "none", module: "timesheets", parentRouteName: "", pageTitle: "Record Time", kbFile: "timesheet-record-time", kbTitle: "Timesheet > Record Time" } 
	},



	// Reports
	{ 
		path: '/module/timesheets/reports/timesheet-summary-report', 
		name: "timesheet-summary-report", 
		component: () => import("/module.timesheets/reports/timesheet-summary-report.vue"),
		meta: { layout: "primary", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "Timesheet Summary Report", kbFile: "timesheet-summary-report", kbTitle: "Timesheet > Reports" }
	},








		

		//---- "Keywords" pages
		{ 
			path: '/module/timesheets/keywords/new-detected', 
			name: "timesheets-new-detected-keywords", 
			component: () => import("/module.timesheets/keywords/new-detected.vue"),
			meta: { layout: "primary", section: "keywords", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "New Detected" }
		},






		{ 
			path: '/module/timesheets/admin', 
			name: "timesheets-admin-index", 
			component: () => import("/module.timesheets/admin/index.vue"),
			meta: { layout: "primary", module: "timesheets", parentRouteName: "home-timesheets-view", pageTitle: "Admin" }
		},



		//-- 
		{ 
			path: '/module/timesheets/windows-agent/current-activity', 
			name: "timesheets-windows-agent-current-activity", 
			component: () => import("/module.timesheets/windows-agent/current-activity.vue"),
			//meta: { layout: "primary", module: "timesheets", pageTitle: "My Timesheet > Current Activity" }
			meta: { layout: "no", isPublic: false, module: "timesheets", parentRouteName: "", pageTitle: "Current Activity", kbFile: "", kbTitle: "" } 
		},


]


export default routes;